'use client'
import React, { ReactElement } from 'react'
import { Geolocation } from '@/lib/interfaces'
import Card from '@/components/controls/Card'
import Button from '@/components/controls/Button'

interface SelectAddressFormProps {
  addresses: Geolocation[]
  onAddressSelect: (address: Geolocation) => void
  onCancel?: () => void
}

const SelectAddressForm = ({
  addresses,
  onAddressSelect,
  onCancel
}: SelectAddressFormProps): ReactElement => {
  const handleAddressClick = (address: Geolocation) => {
    onAddressSelect(address)
  }

  return (
    <Card className="w-full max-w-md bg-white/95 backdrop-blur-sm">
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-card-foreground mb-2">
          Select Your Address
        </h2>
        <p className="text-muted-foreground">
          Please select your address to continue.
        </p>
      </div>

      <div className="space-y-3">
        {addresses.map((address) => (
          <button
            key={address.id}
            onClick={() => handleAddressClick(address)}
            className="w-full p-4 text-left border border-border rounded-lg hover:bg-accent hover:text-accent-foreground transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 group cursor-pointer"
          >
            <div className="flex flex-col space-y-1">
              <div className="font-medium text-card-foreground group-hover:text-accent-foreground">
                {address.street}
              </div>
              <div className="text-sm text-muted-foreground group-hover:text-accent-foreground/80">
                {address.city}, {address.state} {address.zip}
              </div>
              {address.county && (
                <div className="text-xs text-muted-foreground group-hover:text-accent-foreground/60">
                  {address.county} County
                </div>
              )}
            </div>
          </button>
        ))}
      </div>

      {onCancel && (
        <div className="mt-6 pt-4 border-t border-border">
          <Button
            variant="outline"
            onClick={onCancel}
            className="w-full"
          >
            Cancel
          </Button>
        </div>
      )}
    </Card>
  )
}

export default SelectAddressForm

